import Vue from 'vue'
import App from './App.vue'
import 'es6-promise/auto'
import 'babel-polyfill'
import router from './router'
import store from './store'
import axios from 'axios'
import VueMetaInfo from 'vue-meta-info'
import BootstrapVue from 'bootstrap-vue'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'swiper/dist/css/swiper.css'
import pkg from '../package.json'
import '@/utils/sentry'
// custom plugins
import GlobalComponents from '@/components/global'

import filters from '@/utils/filters'
import sniffer from '@/utils/sniffer'
import preloader from '@/utils/preloader'
import lottie from 'vue-lottie'
import globalVariables from '@/global_variables'

/** 按需引入 element-ui 日期选择组件 */
import 'element-ui/lib/theme-chalk/index.css'
import {
  Popover,
  Tabs,
  TabPane,
  TableColumn,
  Backtop,
  Icon,
  Breadcrumb,
  BreadcrumbItem
} from 'element-ui'
Vue.use(Popover)
Vue.use(Tabs)
Vue.use(TabPane)
Vue.use(TableColumn)
Vue.use(Backtop)
Vue.use(Icon)
Vue.use(Breadcrumb)
Vue.use(BreadcrumbItem)
// 全局挂载EvnetBus
Vue.prototype.$EventBus = new Vue()
Vue.prototype.$globalVariables = globalVariables
Vue.config.productionTip = false

Object.keys(filters).forEach(v => Vue.filter(v, filters[v]))

Vue.prototype.$sniffer = sniffer
Vue.prototype.$axios = axios

Vue.use(VueMetaInfo)
Vue.use(BootstrapVue)
Vue.use(VueAwesomeSwiper)
Vue.use(GlobalComponents)
Vue.component('lottie', lottie)

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')

// preload some images
preloader.init()

console.log(`APP ${pkg.name} v${pkg.version} is running`)
